import { FunctionComponent, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useDispatch } from '@cbridge-utils/react-redux';
import { UserSettingsAction } from '@cbridge-packages/user-settings';
import { LanguageSwitcher } from '@cbridge-modules/language-switcher';
import { LANGUAGE_SETTING_KEY, languages } from '../i18n/i18n.constant';

const LanguageSection = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  gap: theme.spacing(0.5),
}));

// The account Popover closes on any click inside it; the select and its menu must not trigger that.
const stopPropagation = (event: MouseEvent) => event.stopPropagation();

/** Language section of the account menu; shown even with a single language, hidden only while nothing is synced. */
export const AccountLanguage: FunctionComponent = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  if (languages.length === 0) {
    return null;
  }

  // The choice is saved to the profile; LanguageSync applies it, so every device follows the same setting.
  const handleLanguageChange = (language: string) => {
    dispatch(UserSettingsAction.saveSetting({ key: LANGUAGE_SETTING_KEY, value: language }));
  };

  return (
    <>
      <LanguageSection onClick={stopPropagation}>
        <Typography variant={'caption'} color={'text.secondary'}>
          {t('text:common.field.language.label')}
        </Typography>
        <LanguageSwitcher
          fullWidth={true}
          languages={languages}
          value={i18n.resolvedLanguage ?? i18n.language}
          onChange={handleLanguageChange}
        />
      </LanguageSection>
      <Divider />
    </>
  );
};
